import { projects } from '../../siteData/Projects';
import ProjectsGrid from '../../components/ProjectsGrid/ProjectsGrid';
import SEO from '../../components/SEO/SEO';

const FoodAndBeverages = () => {
  return (
    <>
      <SEO
        title='Commercial Food and Beverage photography in Bangalore'
        description='Premium food and FMCG product photography and videography in Bangalore, for brands like Fortune, Anand Sweets, Tilt, Soju. Recipe videos, restaurant films, and advertisements.'
        keywords='food photography Bangalore, product photography Bangalore, commercial photography studio, food videography Bangalore, product videography services, ad film production Bangalore'
        url='https://mudrost.in/food&beverage'
        itempropDescription='Mudrost Studio – Bangalore’s top creative studio for food photography, product photography, and high-end brand videography.'
      />
      <ProjectsGrid projects={projects} category={'foodandbeverages'} />
    </>
  );
};

export default FoodAndBeverages;
